const form = {
  init() {
    const fileInput = document.querySelector('.js-form-file-input');
    if(fileInput) {
      fileInput.addEventListener('change', (e) => {
        const target = e.target;
        const parent = target.closest('.js-form-file');

        if (parent) {
          const nameTarget = parent.querySelector('.js-form-file-name');

          if (nameTarget) {
            if (target.files[0] && nameTarget) {
              nameTarget.textContent = target.files[0].name;
            } else {
              nameTarget.textContent = '';
            }
          }
        }
      }, false);
    }

    if(document.querySelector('.js-form')) {
      document.addEventListener('wpcf7mailsent', (e) => {
        const redirect = e.target.parentNode.dataset.redirect;

        if(redirect !== undefined && redirect) {
          window.location.href = redirect;
        }
      }, false);
    }
  },
};

export default form;



// WEBPACK FOOTER //
// ./scripts/modules/form.js